export default class AvatarsSlider {
    constructor(element) {
        this.index = 0
        this.avatars = [
            {
                url: "/build/img/create-online-school/avatars/1.jpg",
                name: "Andrew Miller",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/2.jpg",
                name: "Hailey Richardson",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/3.jpg",
                name: "Olivia Hall",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/4.jpg",
                name: "Benjamin Hall",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/5.jpg",
                name: "Ryan Westling",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/6.jpg",
                name: "Emily Daniels",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/7.jpg",
                name: "Jonathan Cruz",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/8.jpg",
                name: "Katherine Lynn",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/9.jpg",
                name: "Anna Martin",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/10.jpg",
                name: "Madison Hughes",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/11.jpg",
                name: "Lauren Morgan",
                job: "student"
            },
            {
                url: "/build/img/create-online-school/avatars/12.jpg",
                name: "Nicholas Black",
                job: "student"
            }
        ]
        this.interval = 3000
        this.element = element
    }
    changeIndex() {
        this.index === this.avatars.length - 1 ? (this.index = 0) : this.index++
    }
    changAvatars() {
        setInterval(() => {
            let person = this.avatars[this.index]
            this.element.querySelector(".slider_avatar__name").innerText = person.name
            this.element.querySelector(".slider_avatar__job").innerText = person.job
            this.element.querySelector(".slider_avatar__image").src = person.url
            this.changeIndex()
        }, this.interval)
    }
}
